import { appBus } from '@/modules/app'

export function debugAppBus() {
  appBus.commands.on('*', (e: any, p: any) => {
    console.debug('%cappBus', 'color:blue', { command: e }, p)
  })
  appBus.events.on('*', (e: any, p: any) => {
    console.debug('%cappBus', 'color:green', { event: e }, p)
  })
}
